module.exports = __webpack_public_path__ + "static/media/instagram.3a1cf849.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/instagram.svg
// module id = 83
// module chunks = 0